import { type AggResponse, fetchAgg } from '../../../common/utils/fetch-agg';
import { inMemoryCache } from '../../../utils/caching/in-memory';

const GQL_ASSETS_SCHEMAS_NAME = 'SearchPageAssetsSchemasQuery';
const assetsSchemasQueryString = `query ${GQL_ASSETS_SCHEMAS_NAME}(
	$schemaARIs: [ID!]!) {
		assets_schemasByIds(ids: $schemaARIs) {
    		id
    		key
    		name
    		sequentialId @optIn(to: "AssetsApFields")
  		}
	}`;

export const assetsSchemasCache = inMemoryCache<AggResponse<AssetsSchemasResponse>>();

export type AssetsSchemasQueryVariables = {
	schemaARIs: string[];
};

export type AssetsSchemasResponse = {
	assets_schemasByIds: {
		id: string;
		key: string;
		name: string;
		sequentialId: string;
	}[];
};

export const assetsSchemasQuery = async (schemaARIs: string[]) => {
	return assetsSchemasCache.inMemoryDecorator(`${schemaARIs}`, async () => {
		const response = await fetchAgg<AssetsSchemasQueryVariables, AssetsSchemasResponse>({
			graphQuery: assetsSchemasQueryString,
			variables: {
				schemaARIs,
			},
			headers: {
				'X-ExperimentalApi': 'AssetsSchemas',
			},
		});

		const hasErrors = response.errors?.some((error) => error);

		if (hasErrors) {
			return Promise.reject(response);
		}

		return response;
	});
};
